import mockPosition from './position.mock.js';
const mockPosition2160 = mockPosition[2160];
const mockPosition1080 = mockPosition[1080];

export default (graph) => {
    let options = {
        onTicked: () => {
            if ($qsObj && $qsObj.fixed !== 'false') {
                graph.nodesGroup.each(d => {
                    // 2160拖拽
                    if (window._screenType === '2160') {
                        let nodesPosition = mockPosition2160[d.rootId];
                        if (nodesPosition && graph.tickNum <= 113) {
                            let node = nodesPosition[d.id_origin];
                            if (!node) {
                                console.log(node);
                                debugger
                            } else {
                                d.x = node.x - 100;
                                d.y = node.y;
                            }

                        } else {
                            // console.log('2160-none');
                        }
                    } else if (window._screenType === '1080') {
                        let nodesPosition = mockPosition1080[d.rootId];
                        if (nodesPosition && graph.tickNum <= 113) {
                            d.x = nodesPosition[d.id_origin].x;
                            d.y = nodesPosition[d.id_origin].y;
                        } else {
                            // console.log('1080-none');
                        }
                    }
                });
            }

            // let dataPos = mockPos.main;
            // if (graph.tickNum <= 112) {
            //     graph.nodesGroup.each(d => {
            //         let x = dataPos[d.id].x;
            //         let y = dataPos[d.id].y;
            //         x = x * widthScale;
            //         y = y * heightScale;
            //
            //         d.x = x;
            //         d.fx = x;
            //         d.y = y;
            //         d.fy = y;
            //     });
            // }
        },
        canDrag: (d) => {
            // 大屏核心POI不允许拖拽
            if (mockPosition[d.rootId] && window['_screenType'] === '2016') {
                return false;
            }
        }
    };

    graph.setOption(options);
};

